module.exports = __webpack_public_path__ + "img/fondo6.6f3105cd.jpg";